import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { MissingCardPaymentMutableAttributes } from "../../domain/models/MissingCardPayment";
import { missingCardPaymentMutationService } from "../../services/payments/MissingCardPaymentMutationService";
type UpdateMissingCardPaymentInput = {
  id: string;
  attributes: MissingCardPaymentMutableAttributes;
};
export function useUpdateMissingCardPayment() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["payments", "missing-card-payments"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
function _temp(t0) {
  const {
    id,
    attributes
  } = t0;
  return missingCardPaymentMutationService.update(id, attributes);
}